import SVG from 'react-inlinesvg';
import classnames from 'classnames';
import React from 'react';

import FileIcon from '@krea/common/images/svg/file.svg';

import styles from './FilePreview.module.scss';

const FilePreview = ({ title }) => {
  return (
    <div className={classnames('d-flex align-items-center mt-2')}>
      <div className={classnames(styles.icon, 'position-relative shrink-0')}>
        <SVG className="position-absolute w-100 h-auto" src={FileIcon} />
      </div>
      <div className="w-100 pl-2 text-truncate">{title}</div>
    </div>
  );
};

export default FilePreview;
